import type { Section } from "@/hooks/use-path-route";

type Props = {
  readonly value: Section;
  readonly onChange: (s: Section) => void;
};

const OPTIONS: ReadonlyArray<{ id: Section; label: string }> = [
  { id: "loop", label: "Multiply" },
  { id: "supply", label: "Supply" },
];

/**
 * Top-level product navigation, shown in the header beside the wordmark. Styled
 * as text links to match the external nav links, with the active section
 * carried in full-strength ink.
 */
export const SectionNav = ({ value, onChange }: Props) => (
  <nav role="radiogroup" aria-label="Section" className="flex items-baseline gap-6">
    {OPTIONS.map((opt) => {
      const active = value === opt.id;
      return (
        <button
          key={opt.id}
          role="radio"
          aria-checked={active}
          type="button"
          onClick={() => onChange(opt.id)}
          className="font-sans text-[12px] tracking-[0.12em] uppercase transition-colors"
          style={{ color: active ? "var(--ink-3)" : "var(--ink-2)", fontWeight: active ? 600 : 400 }}
        >
          {opt.label}
        </button>
      );
    })}
  </nav>
);
